import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";


function generateChartData() {
var chartData = [];
// current date
var firstDate = new Date();
// now set 500 minutes back
firstDate.setMinutes(firstDate.getDate() - 1000);

// and generate 500 data items
var visits = 500;
for (var i = 0; i < 500; i++) {
    var newDate = new Date(firstDate);
    // each time we add one minute
    newDate.setMinutes(newDate.getMinutes() + i);
    // some random number
    visits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);
    // add data item to the array
    chartData.push({
        date: newDate,
        visits: visits
    });
}
return chartData;
}

class AreaChart extends Component {

    constructor(props) {
        super(props);


        this.state = {
            dataProvider: ''

        };
    }

    componentDidMount() {

                this.setState({
                    chartData: generateChartData()
                });


    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() {
        const config = {
            "type": "serial",
            "theme": "none",
            "marginRight": 50,
            "dataProvider": this.state.chartData,
            "valueAxes": [{
                "position": "left",
                "title": "Unique visitors"
            }],
            "graphs": [{
                "id": "g1",
                "fillAlphas": 0.4,
                "valueField": "visits",
                "balloonText": "<div style='margin:5px; font-size:12px;'>Visits:<b>[[value]]</b></div>"
            }],
            "chartScrollbar": {
                "enabled":false,
                "graph": "g1",
                "scrollbarHeight": 80,
                "backgroundAlpha": 0,
                "selectedBackgroundAlpha": 0.1,
                "selectedBackgroundColor": "#888888",
                "graphFillAlpha": 0,
                "graphLineAlpha": 0.5,
                "selectedGraphFillAlpha": 0,
                "selectedGraphLineAlpha": 1,
                "autoGridCount": true,
                "color": "#AAAAAA"
            },
            "chartCursor": {
                "categoryBalloonDateFormat": "JJ:NN, DD MMMM",
                "cursorPosition": "mouse"
            },
            "categoryField": "date",
            "categoryAxis": {
                "minPeriod": "mm",
                "parseDates": true
            },
            "export": {
                "enabled": true,
                "dateFormat": "YYYY-MM-DD HH:NN:SS"
            }

        };
        return (
            <div >
                <AmCharts.React style={{ width: "100%", height: "250px" }} options={config} />
            </div>
        );
    }
}

export default AreaChart;